import { Button } from "antd";
import { useState } from "react";
import UpsertConductModal from "~pages/Conducts/components/UpsertConductModal.tsx";
import type { ConductTransformed } from "~pages/Conducts/types/conductTransformed.ts";
import type { UpsertConductData } from "~pages/Conducts/types/upsertConductData.ts";

type Props = {
  conduct: ConductTransformed;
  onUpdate: (upsertData: UpsertConductData) => void;
  isUpdateInProcess: boolean;
};

const UpdateConductAction = ({ conduct, onUpdate, isUpdateInProcess }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <Button onClick={() => setOpenModal(true)} type={"text"} size={"small"} icon={<i className="fas fa-pen-to-square" />} />
      {openModal && (
        <UpsertConductModal
          conduct={conduct}
          onUpsert={onUpdate}
          onClose={() => setOpenModal(false)}
          isUpsertInProcess={isUpdateInProcess}
        />
      )}
    </>
  );
};

export default UpdateConductAction;
